import { post } from '@core/api/baseApi';
import { ExportStatusView } from '@core/signalr/types';

export interface ExportStudyResponse {
  status: ExportStatusView;
  downloadUrl: string | null;
  failureReason: string | null;
}

export const requestExport = (studyInstanceUid: string): Promise<ExportStudyResponse> =>
  post(`/studies/${encodeURIComponent(studyInstanceUid)}/export`) as Promise<ExportStudyResponse>;
